import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from '@env/environment';
import { Amplify } from 'aws-amplify';
import { amplifyConfig } from 'amplify.config';

if (environment.production) enableProdMode();

Amplify.configure(amplifyConfig);

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));